// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"eo-z","badgeLink":"fo-z","category":"go-z"};